import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/totalRevenueSagas";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import PreviousYearMonthToDate from "./smartComponents/previousYearMonthToDate";
import RevenueLearnMore from "./smartComponents/revenueLearnMore";
import RevenueByType from "./smartComponents/revenueByType";
import YearOverYear from "./smartComponents/yearOverYear";
import MonthToDate from "./smartComponents/monthToDate";
import YearToDate from "./smartComponents/yearToDate";
import Forecast from "./smartComponents/forecast";
import { useFetchDataWithRevenueType } from "../hooks/dataFetchingHooks";
import { RollingViewToggle } from "./smartComponents/rollingViewToggle";

const TotalRevenueModule = (props) => {
  useFetchDataWithRevenueType({
    moduleName: "totalRevenue",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });
  const isLoading = useSelector((state) => state.totalRevenue.isLoading);

  const content = () => {
    return (
      <div style={{ marginBottom: "40px", overflow: "hidden" }}>
        <div className="section-group">
          <span className="width-50">
            <SectionContainer title="Month To Date">
              <MonthToDate />
            </SectionContainer>
          </span>
          <span className="width-50">
            <SectionContainer title="Month to Date this time Last Year">
              <PreviousYearMonthToDate />
            </SectionContainer>
          </span>
          <SectionContainer title="Revenue By Category MTD">
            <RevenueByType />
          </SectionContainer>
        </div>
        <div className="section-group">
          <span className="width-50">
            <Forecast />
          </span>
          <span className="width-50">
            <SectionContainer title="Year to Date">
              <YearToDate />
            </SectionContainer>
          </span>
          <div className="section-container">
            <RollingViewToggle />
            <YearOverYear />
          </div>
        </div>
      </div >
    );
  };

  return (
    <SectionToggle
      title="Total Revenue"
      customClass="revenueWidget"
      isLoading={isLoading}
      content={content()}
      learnMore={<RevenueLearnMore />}
    />
  );
};

export default React.memo(TotalRevenueModule);
